import React from 'react';

export type GuidesToggleCardContentProps = {
    children?: React.ReactNode | React.ReactNode[];
};

const GuidesToggleCardContent: React.FC<GuidesToggleCardContentProps> = (props) => {
    const { children } = props;

    return (
        <div className="guides-toggle-card-content is-mobile">
            <div className="guides-toggle-card-content__inner">{children}</div>
        </div>
    );
};

export default GuidesToggleCardContent;
